import { COLORS } from '../../config/colors';
import { LottieAnimation } from '../../config/lottie';
import { AvailableAppVariants } from '../enums';
import { ThemeAssets, ThemeColorScheme, ThemeStyles } from '../types';

/**
 * @WHITE_LABEL_CHANGES
 */

export const APP_CONFIG: {
  [theme: string]: {
    colorScheme: ThemeColorScheme;
    assets: ThemeAssets;
    styles: ThemeStyles;
  };
} = {
  [AvailableAppVariants.PulseEnergyLite]: {
    colorScheme: {
      defaultStatusBar: COLORS.whiteColor,
      primaryColor: COLORS.primaryColor,
      primaryLight: COLORS.primaryLight,
      primaryDark: COLORS.darkblue,
      primaryBorder: COLORS.primaryLight,
      bgColor: COLORS.lightPrimaryBackgroundColor,
      bgHeader: COLORS.whiteColor,
      bgSecondary: COLORS.whiteColor,
      textColor: COLORS.blackColor,
      bgDark: COLORS.primaryColor,
      borderColor: COLORS.primaryLight,
      neutralBorderColor: COLORS.grey300,
      inputBorder: COLORS.blackColor,
      buttonBgColor: COLORS.blackColor,
      buttonBgColor2: COLORS.cyanColorLight,
      sectionHeader: COLORS.blackColor,
      // semi generic
      countBadgeText: COLORS.darkBlack,
      countBadgeBg: COLORS.whiteColor,
      cardUnderlayBgColor: COLORS.grey100,
      cardBorderColor: COLORS.primaryLight,
      cardSelectedBgColor: COLORS.cyanColor,
      cardSelectedBgUnderlayColor: COLORS.cyanColor2,
      cardUnselectedBgUnderlayColor: COLORS.lightGrey,
      cardUnselectedBgColor: COLORS.whiteColor,
      cardSelectedTextColor: COLORS.darkBlack,
      cardUnselectedTextColor: COLORS.darkBlack,
      // components
      selectedPaymentMethodNameText: COLORS.darkBlack,
      unselectedPaymentMethodNameText: COLORS.darkBlack,
      walletBarAppWalletBgColor: COLORS.blackTint,
      walletBarNonAppWalletBgColor: COLORS.whiteColor,
      quickFilterItemSelectedBg: COLORS.primaryDark,
      quickFilterItemSelectedText: COLORS.darkBlack,
      quickFilterItemUnselectedText: COLORS.darkBlack,
      nearestCSContainerText: COLORS.whiteColor,
      nearestCSContainerSubText: COLORS.grey400,
      nearestCSContainerBg: COLORS.darkBlack,
      qrCodeTopHalfBg: COLORS.primaryColor,
      qrCodeBottomHalfBg: COLORS.skyBlue,
      secondaryTextColor: COLORS.blackColor,
      buttonBgColor3: '',
      cardSelectedBorderColor: COLORS.blackColor,
      cardUnselectedBorderColor: COLORS.primaryLight10,
      subTextColor: COLORS.greyText,
      textColorOnDarkBg: COLORS.darkBlack,
    },
    assets: {
      FullLogoVector: 'InstaChargeLogo',
      FullLogoUrl: require('./../../assets/image/logo.png'),
      SearchingRipple: LottieAnimation.searching_ripple,
      Check: LottieAnimation.check,
    },
    styles: {
      item: {
        backgroundColor: COLORS.whiteColor,
        borderWidth: 1,
        borderColor: COLORS.grey300,
        borderRadius: 8,
        padding: 8,
      },
      itemSelected: {
        backgroundColor: COLORS.whiteColor,
        borderColor: COLORS.grey300,
      },
      input: {
        borderWidth: 1,
        // borderBottomWidth: 3,
        borderColor: COLORS.blackColor,
        backgroundColor: COLORS.whiteColor,
        borderRadius: 8,
        height: 48
        // marginHorizontal: -10
      },
      buttonStyle : {
        borderRadius: 12,
      },
      // buttonBorder: {
      //   borderBottomWidth: 1
      // },
      homeScreenLogo: {
        width: 120,
        height: 25
      },
      cardStyle : {
        borderRadius: 22,
      },
      themeBorder: {
        borderColor: COLORS.primaryLight,
        borderWidth: 1,
        borderBottomWidth: 1,
        // borderBottomWidth: 3,
        borderRadius: 16
      },
      connectorId: {
        backgroundColor: COLORS.whiteColor,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: COLORS.primaryLight,
      },
      chip: {
      },
      videoCont: {
        padding: 16,
        alignSelf: "center",
        borderRadius: 180,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 180,
        width: 180,
        // backgroundColor: THEME_COLORS.primaryBorder,
      },
    }
  },
  [AvailableAppVariants.TataMotorsLite]: {
    colorScheme: {
      defaultStatusBar: COLORS.TataMotorsDarkGreyBg,
      // primaryColor: COLORS.TataMotorsDarkGreyBg,
      primaryColor: COLORS.TataMotorsPrimary,
      primaryLight: COLORS.TataMotorsPrimaryLight,
      primaryBorder: COLORS.grey200,
      primaryDark: COLORS.TataMotorsSecondaryButtonBg,
      bgColor: COLORS.TataMotorsBlackBg,
      bgSecondary: COLORS.TataMotorsDarkGreyBg,
      bgHeader: COLORS.whiteColor,
      textColor: COLORS.whiteColor,
      secondaryTextColor: COLORS.blackColor,
      bgDark: COLORS.primaryColor,
      borderColor: COLORS.TataMotorsBorder,
      neutralBorderColor: COLORS.TataMotorsBorder,
      inputBorder: COLORS.blackColor,
      buttonBgColor: COLORS.TataMotorsButtonBg,
      buttonBgColor2: COLORS.TataMotorsDarkGreyBg,
      buttonBgColor3: COLORS.TataMotorsSecondaryButtonBg,
      sectionHeader: COLORS.whiteColor,
      subTextColor: COLORS.TataMotorsGreyBg,
      // semi generic
      countBadgeText: COLORS.darkBlack,
      countBadgeBg: COLORS.whiteColor,
      cardUnderlayBgColor: COLORS.grey800,
      cardBorderColor: COLORS.blackColor,
      cardSelectedBgColor: COLORS.TataMotorsButtonBg,
      cardSelectedBgUnderlayColor: COLORS.TataMotorsSecondaryButtonBg,
      cardUnselectedBgUnderlayColor: COLORS.lightGrey,
      cardUnselectedBgColor: COLORS.TataMotorsDarkGreyBg,
      cardSelectedTextColor: COLORS.TataMotorsButtonBg,
      cardUnselectedTextColor: COLORS.whiteColor,
      // components
      selectedPaymentMethodNameText: COLORS.darkBlack,
      unselectedPaymentMethodNameText: COLORS.darkBlack,
      walletBarAppWalletBgColor: COLORS.blackTint,
      walletBarNonAppWalletBgColor: COLORS.whiteColor,
      quickFilterItemSelectedBg: COLORS.TataMotorsButtonBg,
      quickFilterItemSelectedText: COLORS.whiteColor,
      quickFilterItemUnselectedText: COLORS.whiteColor,
      nearestCSContainerText: COLORS.whiteColor,
      nearestCSContainerSubText: COLORS.grey400,
      nearestCSContainerBg: COLORS.darkBlack,
      qrCodeTopHalfBg: COLORS.TataMotorsDarkGreyBg,
      qrCodeBottomHalfBg: COLORS.TataMotorsDarkGreyBg,

      // Card
      cardSelectedBorderColor: COLORS.TataMotorsButtonBg,
      cardUnselectedBorderColor: COLORS.TataMotorsUnselectedBorder,

      textColorOnDarkBg: COLORS.darkBlack,
    },
    assets: {
      FullLogoVector: 'TataMotorsLogo',
      FullLogoUrl: require('./../../assets/image/tata-motors-logo.png'),
      SearchingRipple: LottieAnimation.searching_ripple_tatamotors,
      Check: LottieAnimation.check_tatamotors,
    },
    styles: {
      item: {
        backgroundColor: COLORS.whiteColor,
        borderWidth: 1,
        borderColor: COLORS.grey300,
        borderRadius: 8,
        padding: 8,
      },
      itemSelected: {
        backgroundColor: COLORS.whiteColor,
        borderColor: COLORS.grey300,
      },
      input: {
        borderWidth: 1,
        // borderBottomWidth: 3,
        borderColor: COLORS.blackColor,
        backgroundColor: COLORS.whiteColor,
        borderRadius: 0,
        height: 48,
        color: COLORS.blackColor,
        // marginHorizontal: -10
      },
      themeBorder: {
        borderColor: COLORS.TataMotorsUnselectedBorder,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderRadius: 0,
        backgroundColor: COLORS.TataMotorsDarkGreyBg
      },
      buttonStyle : {
        borderRadius: 0,
      },
      cardStyle : {
        borderRadius: 0,
        borderWidth: 0
      },
      // defaultCardStyle : {

      // },
      buttonBorder: {
        borderRadius : 0,
        borderWidth: 0,
        borderBottomWidth: 0,
      },
      homeScreenLogo: {
        width: 120,
        height: 25
      },
      connectorId: {
        // backgroundColor: COLORS.whiteColor,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: COLORS.grey800,
        color: COLORS.whiteColor,
      },
      chip: {
        backgroundColor: COLORS.TataMotorsBlackBg,
        borderWidth: 0,
        borderBottomWidth: 0,
      },
      videoCont: {
        // padding: 16,
        alignSelf: "center",
        // borderRadius: 180,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        // height: 180,
        width: '50%',
        // backgroundColor: THEME_COLORS.primaryBorder,
      }
    }
  },
  [AvailableAppVariants.ThunderPlusLite]: {
    colorScheme: {
      defaultStatusBar: COLORS.whiteColor,
      primaryColor: COLORS.ThunderPlusPrimary,
      primaryLight: COLORS.ThunderPlusPrimaryLight,
      primaryDark: COLORS.ThunderPlusPrimaryDark,
      primaryBorder: COLORS.ThunderPlusPrimaryLight,
      bgColor: COLORS.ThunderPlusBgColor,
      bgHeader: COLORS.whiteColor,
      bgSecondary: COLORS.whiteColor,
      textColor: COLORS.blackColor,
      bgDark: COLORS.ThunderPlusPrimary,
      borderColor: COLORS.ThunderPlusPrimaryLight,
      neutralBorderColor: COLORS.grey200,
      inputBorder: COLORS.blackColor,
      buttonBgColor: COLORS.blackColor,
      buttonBgColor2: COLORS.cyanColorLight,
      sectionHeader: COLORS.blackColor,
      // semi generic
      countBadgeText: COLORS.darkBlack,
      countBadgeBg: COLORS.whiteColor,
      cardUnderlayBgColor: COLORS.grey100,
      cardBorderColor: COLORS.grey300,
      cardSelectedBgColor: COLORS.ThunderPlusPrimary,
      cardSelectedBgUnderlayColor: COLORS.grey100,
      cardUnselectedBgUnderlayColor: COLORS.lightGrey,
      cardUnselectedBgColor: COLORS.whiteColor,
      cardSelectedTextColor: COLORS.darkBlack,
      cardUnselectedTextColor: COLORS.darkBlack,
      // components
      selectedPaymentMethodNameText: COLORS.darkBlack,
      unselectedPaymentMethodNameText: COLORS.darkBlack,
      walletBarAppWalletBgColor: COLORS.blackTint,
      walletBarNonAppWalletBgColor: COLORS.whiteColor,
      quickFilterItemSelectedBg: COLORS.ThunderPlusPrimaryDark,
      quickFilterItemSelectedText: COLORS.darkBlack,
      quickFilterItemUnselectedText: COLORS.darkBlack,
      nearestCSContainerText: COLORS.whiteColor,
      nearestCSContainerSubText: COLORS.grey400,
      nearestCSContainerBg: COLORS.darkBlack,
      qrCodeTopHalfBg: COLORS.ThunderPlusPrimary,
      qrCodeBottomHalfBg: COLORS.skyBlue,
      secondaryTextColor: COLORS.blackColor,
      buttonBgColor3: '',
      cardSelectedBorderColor: COLORS.ThunderPlusPrimaryLight,
      cardUnselectedBorderColor: COLORS.grey300,
      subTextColor: COLORS.greyText,
      textColorOnDarkBg: COLORS.darkBlack,
    },
    assets: {
      FullLogoVector: 'ThunderLogo',
      FullLogoUrl: require('./../../assets/image/thunder-logo.png'),
      SearchingRipple: LottieAnimation.searching_ripple_thunderpluslite,
      Check: LottieAnimation.check_thunderplus,
    },
    styles: {
      item: {
        backgroundColor: COLORS.whiteColor,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderColor: COLORS.grey300,
        borderRadius: 10,
        padding: 8,
      },
      itemSelected: {
        backgroundColor: COLORS.whiteColor,
        borderColor: COLORS.ThunderPlusPrimaryLight,
      },
      input: {
        borderWidth: 1,
        // borderBottomWidth: 3,
        borderColor: COLORS.blackColor,
        backgroundColor: COLORS.whiteColor,
        borderRadius: 8,
        height: 48
        // marginHorizontal: -10
      },
      buttonStyle : {
        borderRadius: 12,
      },
      buttonBorder: {
        // borderBottomWidth: 1
        borderColor: COLORS.grey300,
      },
      homeScreenLogo: {
        width: 120,
        height: 25
      },
      cardStyle : {
        borderRadius: 22,
      },
      themeBorder: {
        borderColor: COLORS.ThunderPlusPrimaryLight,
        borderWidth: 1,
        borderBottomWidth: 1,
        // borderBottomWidth: 3,
        borderRadius: 16
      },
      connectorId: {
        backgroundColor: COLORS.whiteColor,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: COLORS.ThunderPlusPrimaryLight,
      },
      chip: {
        
      },
      videoCont: {
        padding: 16,
        alignSelf: "center",
        borderRadius: 180,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 180,
        width: 180,
        // backgroundColor: THEME_COLORS.primaryBorder,
      },
    }
  },
};